import firebase from '@firebase/app'
import '@firebase/database'

const state = {
  sections: [],
  sectionsRef: null,
  sectionsLoaded: false
}

const getters = {
  sections (state) {
    return state.sections
  },
  sectionsRef (state) {
    return state.sectionsRef
  },
  sectionsLoaded (state) {
    return state.sectionsLoaded
  },
  sectionByKey (state) {
    return (sectionKey) => {
      return state.sections.find(s => {
        return s.key === sectionKey
      })
    }
  },
  sectionByContent (state) {
    return (contentKey) => {
      const contentSections = []
      for (let s of state.sections) {
        if (s.contentKey === contentKey) contentSections.push({...s})
      }
      return contentSections
    }
  },
  sectionByContentByUrl (state) {
    return (contentKey, sectionUrl) => {
      return state.sections.find(s => {
        return (s.url === sectionUrl) && (s.contentKey === contentKey)
      })
    }
  }
}

const mutations = {
  setSections (state, payload) {
    state.sections = payload
  },
  setSectionsRef (state, payload) {
    state.sectionsRef = payload
  },
  setSectionsLoaded (state, payload) {
    state.sectionsLoaded = payload
  }
}

const actions = {
  loadSections: (store, payload) => new Promise((resolve, reject) => {
    const ref = firebase.database().ref('sections')
    ref.on('value', snapshot => {
      const sections = []
      snapshot.forEach(s => {
        sections.push({key: s.key, ...s.val()})
      })
      store.commit('setSectionsRef', ref)
      store.commit('setSections', sections)
      store.commit('setSectionsLoaded', true)
      resolve()
    })
  }),
  createSection: (store, payload) => new Promise((resolve, reject) => {
    const newSection = {...payload}
    store.getters.sectionsRef.push(newSection).then(() => {
      resolve(newSection)
    }).catch(err => {
      reject(err)
    })
  }),
  updateSection: (store, payload) => new Promise((resolve, reject) => {
    const newSection = {...payload}
    store.getters.sectionsRef.child(newSection.key).set(newSection).then(() => {
      resolve(newSection)
    })
  }),
  deleteSection: (store, payload) => new Promise((resolve, reject) => {
    const toDelete = {...payload}
    const tasks = store.getters.taskBySection(toDelete.key)
    if (tasks.length > 0) {
      reject(new Error('Delete section failed, there are tasks in this section'))
    } else {
      store.getters.sectionsRef.child(toDelete.key).remove().then(() => {
        resolve()
      }).catch(err => {
        reject(err)
      })
    }
  }),
  resetSections: (store) => new Promise((resolve, reject) => {
    if (store.getters.sectionsRef) store.getters.sectionsRef.off()
    store.commit('setSections', [])
    store.commit('setSectionsRef', null)
    store.commit('setSectionsLoaded', false)
    resolve()
  })
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/content/section.js